import $ from 'jquery';
import dialogPolyfill from 'dialog-polyfill';
import { debounce } from 'lodash';
import * as bodyScrollLock from 'body-scroll-lock/lib/bodyScrollLock';
import applyAccessRoles from './helpers/apply-access-roles';
import setReturnUrls from './helpers/set-return-urls';
import AccountService from '../_shared/account-service';

/**
 * @desc Manages mobile navigation.
 */
export default class MobileMenu {
  /**
   * @param {Object} options
   * @param {string} options.openButtonSelector
   * @param {string} options.menuModalSelector
   * @param {string} options.closeButtonSelector
   */
  constructor({
    openButtonSelector, menuModalSelector, navSectionSelector, closeButtonSelector,
  } = {}, outerUsage) {
    this.$openButton = $(openButtonSelector);
    this.$menuModal = $(menuModalSelector);
    this.$closeButton = this.$menuModal.find(closeButtonSelector);
    this.$nav = this.$menuModal.find(navSectionSelector);
    this.$html = $('html');
    this.$window = $(window);
    this.$lastFocusedElement = null;
    this.outerUsage = !!outerUsage;

    this.init();
  }

  async init() {
    this.isInitialized = true;

    if (!this.$openButton.length || !this.$menuModal.length || !this.$closeButton.length) {
      this.isInitialized = false;

      return;
    }

    const userData = await AccountService.getUserData();

    applyAccessRoles(this.$menuModal, userData);

    setReturnUrls(this.$menuModal);

    dialogPolyfill.registerDialog(this.$menuModal[0]);

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.$window.on('resize', this.tryToCloseMenu());

    this.$openButton.mousedown(() => this.preserveFocus());

    this.$openButton.click(() => this.openMenu());

    this.$closeButton.click(() => {
      this.closeMenu();
      this.restoreFocus();
    });

    this.$menuModal[0].addEventListener('close', () => {
      bodyScrollLock.enableBodyScroll(this.$nav[0]);

      this.$nav.scrollTop(0);
    });
  }

  tryToCloseMenu() {
    return debounce(() => {
      if (this.$menuModal[0].open && window.matchMedia('(min-width: 1024px)').matches) {
        this.$closeButton.trigger('click');
      }
    }, 200);
  }

  openMenu() {
    this.$menuModal[0].showModal();

    $(document.activeElement).blur();

    bodyScrollLock.disableBodyScroll(this.$nav[0]);
  }

  closeMenu() {
    this.$menuModal[0].close();
  }

  preserveFocus() {
    this.$lastFocusedElement = $(document.activeElement);
  }

  restoreFocus() {
    const elementTop = this.$lastFocusedElement.offset().top;
    const elementBottom = elementTop + this.$lastFocusedElement.offset().top;

    const viewportTop = this.$window.scrollTop();
    const viewportBottom = viewportTop + this.$window.height();

    if (elementBottom > viewportTop && elementTop < viewportBottom) {
      this.$lastFocusedElement.focus();
    }
  }
}
